module.exports = __webpack_public_path__ + "img/web2x_sheji ruanjian.dd43809f.png";